import { useEffect, useState } from "react";
import { UsersService } from "../../../services/users";
import { IOption } from "../../../types/Option";
import USER_ROLES from "../../../types/UserRoles";

export const useFetchUserRoles = () => {
  const [roles, setRoles] = useState<IOption[]>([]);

  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect((): void => {
    UsersService.fetchRolesList()
      .then((res) => {
        setIsLoading(false);

        const val: IOption[] = res
          .filter(
            (role: any) => role.name !== USER_ROLES.INTEGRATION_RECEPTIONIST,
          )
          .map((role: any) => ({
            label: role.name,
            value: role.id,
          }));

        setRoles(val);
      })
      .catch(() => setIsLoading(false));
  }, []);

  return { roles, isLoading };
};
